import React from 'react';
import { Space, Typography } from 'antd';

import { useAppContext } from '@components/AppContext';
import { type AppContext } from '@components/AppContext/types';

const LABEL_CURRENT = 'Current';
const LABEL_NAME = 'Name';

type UseColumnsConfigOptions = {
  onBeforeSwitch: () => Promise<void> | void;
  onAfterSwitch: () => Promise<void> | void;
};

type OrganizationRecord = {
  id: string;
};

type NameColumnProps = {
  key: string;
  title: string;
  render: (value: string, organization: OrganizationRecord) => React.ReactNode;
  isSearchable: boolean;
};

const useColumnsConfig = ({
  onBeforeSwitch,
  onAfterSwitch,
}: UseColumnsConfigOptions): NameColumnProps[] => {
  const { identity, switchToOrganization } = useAppContext() as AppContext;

  const currentOrganizationId = identity?.organization?.id;

  const isCurrentOrganization = (id: string): boolean => id === currentOrganizationId;

  const nameColumnProps: NameColumnProps = {
    key: 'name',
    title: LABEL_NAME,
    render: (value: string, { id }: OrganizationRecord) => (
      isCurrentOrganization(id)
        ? (
          <Space>
            <Typography.Text strong>
              {value}
            </Typography.Text>
            <Typography.Text type="secondary">
              ({LABEL_CURRENT})
            </Typography.Text>
          </Space>
        )
        : (
          <Typography.Link
            strong
            onClick={() => Promise.resolve(onBeforeSwitch())
              .then(() => switchToOrganization(id))
              .then(() => onAfterSwitch())}
          >
            {value}
          </Typography.Link>
        )
    ),
    isSearchable: true,
  };

  return [
    { ...nameColumnProps },
  ];
};

export default useColumnsConfig;
